import { render, staticRenderFns } from "./LootboxContentItem.vue?vue&type=template&id=6512bc0a&"
import script from "./LootboxContentItem.vue?vue&type=script&lang=js&"
export * from "./LootboxContentItem.vue?vue&type=script&lang=js&"
import style0 from "./LootboxContentItem.vue?vue&type=style&index=0&id=6512bc0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports